import React from "react";
// import "./Billing.css"
import "../../GlobalCss/SPF/Billing.css";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import BCSection from "../../Components/BillingCrawling/BCSection";
import { Button, Layout, Modal, Select, Spin, Tooltip, Upload, Image } from "antd";
import { LoadingOutlined, DeleteOutlined } from "@ant-design/icons";
import { UploadOutlined } from "@ant-design/icons";
import { dwnldBillingAutocrawl, downloadBillingAutoCrawledFiles, getFolderUploadedDatebilling } from "../../Repository/BillingRepository";
import { InfoMessage, SuccessMessage, ErrorMessage } from "../../Utils/Utils";
const { Header, Content } = Layout;
import JSZip from "jszip";
import axios from "axios";
import { BaseUrl } from "../../Repository/BaseRepository";
import Cookies from "js-cookie";
import moment from "moment";

const Billing = () => {
    const [loader, setLoader] = useState(false)
    const [buttonLoad, setButtonLoad] = useState(false)
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [enable, setEnable] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [autocrawlData, setAutoCrawlData] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [uploadSpinLoader, setUploadSpinLoader] = useState(false)
    const [manualLoadingFileName, setManualLoadingFileName] = useState('');
    const userLogin = Cookies.get("UserLogin");
    const [dateList, setDateList] = useState(null);

    // useEffect(() => {
    //     callAutocrawl()
    // }, [])
    // const callAutocrawl = async () => {
    //     try {
    //         setEnable(true)
    //         setLoader(true)
    //         const res = await dwnldBillingAutocrawl();
    //         if (res !== null) {
    //             if (res.BatchLabel === "Auto Crawl Process Not Completed") {
    //                 InfoMessage("Autocrawl process is not completed yet !!")
    //             }
    //             else {
    //                 setAutoCrawlData(res)
    //                 setEnable(false)
    //             }
    //         }
    //         setLoader(false)
    //     }
    //     catch {
    //         setLoader(false)
    //     }
    // }
    const openPopup = async () => {
        try {
            setLoader(true)
            setShowErrorMsg(false)
            const res = await dwnldBillingAutocrawl();
            if (res !== null) {
                if (res.BatchLabel === "Auto Crawl Process Not Completed") {
                    setShowErrorMsg(true);
                }
                else {
                    setAutoCrawlData(res)
                    setShowPopup(true);
                }
            }
            setLoader(false)
        }
        catch {
            setLoader(false)
        }
    }
    const closePopup = () => {
        setShowPopup(false)
    }

    const handleFolderUpload = async (options) => {
        try{

            setUploadSpinLoader(true);

            const zipFile = options.file;
            if (!zipFile || !zipFile.name.endsWith(".zip")) {
                ErrorMessage("Please upload a valid ZIP file only.");
                setUploadSpinLoader(false);
                return;
            }

            setManualLoadingFileName(zipFile.name);
            setFileList([]);
    
            const zip = new JSZip();
    
            const zipContent = await zip.loadAsync(zipFile);

            if(Object.keys(zipContent.files).length === 0){
                ErrorMessage(`${zipFile.name} has no files`);
                setManualLoadingFileName('');
                setUploadSpinLoader(false);
                return;
            }
    
            const formData = new FormData();
    
            await Promise.all(
                Object.keys(zipContent.files).map(async (relativePath) => {
                    const entry = zipContent.files[relativePath];
                    if(entry.dir)
                        return
    
                    const fileData = await entry.async("blob");
    
                    formData.append("files", new File ([fileData], relativePath));
                })
            );

            const updatedFile = { file: zipFile, status: "uploading" };
    
            const response = await axios.post(
                `${BaseUrl}Home/FolderUploadFuntionality?moduleName=billing&UserName=${userLogin}`,
                formData
            );
    
            if (response && response.data.statusCode === 200) {
                updatedFile.status = "done";
                setFileList([updatedFile]);
                SuccessMessage(`${zipFile.name} uploaded successfully.`);
            } else {
                updatedFile.status = "error";
                setFileList([updatedFile]);
                ErrorMessage(response.data.message || `${zipFile.name} upload failed.`);
            }

            setUploadSpinLoader(false);
            setManualLoadingFileName('');   
        }
        catch(error) {
            setUploadSpinLoader(false);
            setManualLoadingFileName('');
            ErrorMessage("Something went wrong. Please try again.");
        }
    }

    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (fileList.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ color: statusColor, width: "90%", display: "flex", justifyContent: "space-evenly", marginTop: "10px", }}>{fileExists ? fileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>

        </>;
    };
    // const downloadFiles = async () => {
    //     try {
    //         setButtonLoad(true)
    //         const res = await downloadBillingAutoCrawledFiles()
    //         setButtonLoad(false)
    //     }
    //     catch {
    //         setButtonLoad(false)
    //     }
    // };

    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {
        try{
            const response = await getFolderUploadedDatebilling();
            if(response && response.payload){
                const payloadObject = JSON.parse(response.payload);
                setDateList(payloadObject);
            }
        }
        catch(err){
            console.log(err);
        }
    }

    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="preview-header-class"><Navbar /></Header>
                <Content style={{ overflow: 'auto', height: "100%" }}>
                    <div className="timesheet-first-div">
                        <div className="name-autocrawl">
                            <div className="timesheet-title">
                                <span>Billing</span>
                                <div className="line-class"></div>
                            </div>
                            <div className="notifictaion">
                                <Button type="submit" className="autocrawl-button" onClick={openPopup}
                                    loading={loader}>Auto Crawl</Button>
                                {showErrorMsg ? <div className="status-para">! Autocrawl is processing</div> : null}
                            </div>
                            <div className="ten-manual-upload">
                                <div className="inputfile-upload">
                                    <Upload
                                        className="hr-upload-file1"
                                        name="file"
                                        customRequest={handleFolderUpload}
                                        itemRender={itemRender}
                                        fileList={fileList}
                                        accept=".zip"
                                        onRemove={() => setFileList([])}
                                        style={{ border: "1px solid #3B52DF", borderRadius: 10, borderStyle: "dashed" }}
                                    >
                                        <div className='hr-content-file'>
                                            <span className="hrfile-name">Zip Folder Upload</span>
                                            {uploadSpinLoader ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: -1, color: "#3B52DF" }} spin />} />

                                                // <Spin size="medium" style={{ marginLeft: '5px', marginTop:"3px" }} /> 
                                                : <Image src="/Images/uploadimg (2).png"
                                                    style={{
                                                        border: "none",
                                                        width: 19,
                                                        height: 17,
                                                    }}
                                                    showPreviewIcon={false}
                                                    preview={false} />}
                                        </div>
                                    </Upload>
                                    {manualLoadingFileName.length > 0 ? <div style={{ width: '150px', wordBreak: 'break-all', marginBottom: 2, color: "#3B52DF" ,marginLeft:"25%"}}>{manualLoadingFileName}</div> : null}
                                    <p style={manualLoadingFileName.length > 0 ? { margin: "10px ", width: "350px",color:"blue" }: { margin: "17px 20px", width: "350px", color:"blue" }}>
                                        Last Uploaded Date : {""}
                                        {dateList && dateList.UpdatedDate && moment.utc(dateList.UpdatedDate).tz('Asia/Kolkata').format(
                                            "MM/DD/YYYY HH:mm:ss"
                                        )}

                                    </p>
                                </div>

                            </div>
                        </div>
                        <Modal
                            open={showPopup}
                            className="modal"
                            footer={false}
                            width={400}
                            onOk={openPopup}
                            onCancel={closePopup}

                        >
                            <div style={{ minHeight: 605 }}>
                                <BCSection autocrawl={autocrawlData} setAutoCrawlData={setAutoCrawlData} />
                            </div>
                        </Modal>
                    </div>
                    {/* <div className="billing-second-row">
                        <div className="billingvms-processed-div">
                            <div className="label-div">
                                <label className="billingautocrawl-labels">Total Portals Processed  &nbsp;&nbsp;:</label>
                            </div>
                            <div className="billingprocessed-div">
                                {loader ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} /> :
                                    <label className="billingautocrawl-labels">{autocrawlData.VmsCompletedCount ? autocrawlData.VmsCompletedCount : null}</label>}
                            </div>
                        </div>
                        <div className="billingvms-processed-div" style={{ marginTop: 15 }}>
                            <div className="label-div">
                                <label className="billingautocrawl-labels">Batch Status  &nbsp;&nbsp;:</label>
                            </div>
                            <div className="billingbatch-div">
                                {loader ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} /> :
                                    <label className="billingautocrawl-labels">
                                        {autocrawlData.BatchLabel ? autocrawlData.BatchLabel : null}
                                    </label>}
                            </div>
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <Button className="billing-reports-button" onClick={downloadFiles} loading={buttonLoad} disabled={enable}>
                                Download Auto Crawl Reports</Button>
                        </div>
                    </div> */}
                </Content>
            </Layout>
        </Layout>
    </>)
}
export default Billing;